import Storage from '@/service/Storage';

export default {
  reset: (state) => {
    state.user.token = null;
    state.user.firstName = null;
    state.user.lastName = null;
    state.user.email = null;
    state.user.password = null;
    state.user.confirmationToken = null;
    state.user.invitationCode = null;

    state.currentPassword = null;
    state.currentCourse = null;
    state.currentLectureIndex = 0;
    state.courses = [];
    state.course = null;
    state.invitations = [];

    state.errors.splice(0, state.errors.length);
    Storage.removeItem('token');
  },
  resetErrors: ({ errors }) => {
    errors.splice(0, errors.length);
  },
  resetUserPasswords: (state) => {
    state.user.password = null;
    state.user.currentPassword = null;
  },
  setUser: (state, user) => {
    state.user.firstName = user.firstName || null;
    state.user.lastName = user.lastName || null;
    state.user.email = user.email || null;
    state.user.password = user.password || null;
    state.user.currentPassword = user.currentPassword || null;
    state.user.confirmationToken = user.confirmationToken || null;
    state.user.invitationCode = user.invitationCode || null;
  },
  setToken: (state, token) => {
    state.user.token = token;
    Storage.setItem('token', token);
  },
  setIsLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
  setCurrentCourse: (state, currentCourse) => {
    state.currentCourse = currentCourse;
  },
  setCurrentLectureIndex: (state, currentLectureIndex) => {
    state.currentLectureIndex = currentLectureIndex;
  },
  setCourses: (state, courses) => {
    state.courses = courses;
  },
  setCourse: (state, course) => {
    state.course = course;
  },
  setInvitations: (state, invitations) => {
    state.invitations = invitations;
  },
  addError: ({ errors }, error) => {
    errors.push(error);
  },
  setErrors: (state, errors) => {
    state.errors = errors;
  },
};
